var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9314 12.5565C8.25976 12.5562 9.54984 12.1116 10.5962 11.2933L13.8861 14.583L14.9443 13.5249L11.6544 10.2351C12.4732 9.1887 12.9181 7.89839 12.9185 6.56975C12.9185 3.26881 10.2325 0.583008 6.9314 0.583008C3.63028 0.583008 0.944336 3.26881 0.944336 6.56975C0.944336 9.87069 3.63028 12.5565 6.9314 12.5565ZM6.9314 2.07969C9.4078 2.07969 11.4217 4.09348 11.4217 6.56975C11.4217 9.04602 9.4078 11.0598 6.9314 11.0598C4.455 11.0598 2.4411 9.04602 2.4411 6.56975C2.4411 4.09348 4.455 2.07969 6.9314 2.07969Z",
    fill: "#5E6278"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.c61b654f3300f053808e68107c7f8ad4.svg";
export { ForwardRef as ReactComponent };